/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.getAmazonProductVariants.internal

import features.getAmazonProductVariants.models.RewardResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class GetAmazonProductVariantsServiceImpl : GetAmazonProductVariantsService {

    private val getAmazonProductVariantsRequest = GetAmazonProductVariantsRequest()

    override suspend fun getAmazonProductVariants(
        overrideHeaders : Map<String, String>?,
        rewardId: Int,
        externalProductId: String    ): Result<RewardResponseModel> {
        return getAmazonProductVariantsRequest.getAmazonProductVariants(
            overrideHeaders = overrideHeaders,
            rewardId = rewardId,
            externalProductId = externalProductId        ).toModel()
    }
}
